import { Nullable } from "src/utils";
import { client } from "src/services/client";

export const fetchSimilarHomes = async (query: Nullable<string>) =>
    client({
        method: "get",
        url: `/listings/residential/${query}/details?limit=4`,
    }).then((response) => response.data);
